import gql from 'graphql-tag';

import type { AllInstructionsData } from 'src/data/generation';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { Override } from 'src/lib/types';
import type { BackendMutationLocalizeContentArgs } from 'src/types/backend';

import type { FeedJob } from './generateShortFormAssets';

type Variables = Override<
  BackendMutationLocalizeContentArgs,
  { structureInstructionsData?: AllInstructionsData }
>;

const MUTATION = gql`
  mutation LocalizeContent(
    $projectId: ID!
    $sectionId: ID!
    $contentType: LongFormContentTypeEnum!
    $inputSections: [ImproveSectionInput!]!
    $language: String!
    $tovInput: TovInput
    $structureInstructionsData: JSON
  ) {
    localizeContent(
      projectId: $projectId
      sectionId: $sectionId
      contentType: $contentType
      inputSections: $inputSections
      language: $language
      tovInput: $tovInput
      structureInstructionsData: $structureInstructionsData
    ) {
      id
      status
    }
  }
`;

/**
 * Translates the pasted content into one long-form card in `sectionId`. The backend analyses the
 * text and translates it in the same job, so the card is on the job from its first poll.
 */
export const localizeContent = async (variables: Variables): Promise<FeedJob | null> => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: { traceAcRequests: true },
  });

  return getSingleProp<FeedJob>(response.data) ?? null;
};
